document.addEventListener("DOMContentLoaded", function() {
  // Attach listener to all add to cart buttons in the quick add modal
  document.body.addEventListener('click', function (e) {
      const addButton = e.target.closest('.quick-add-modal .product-form__submit');
      if (addButton) {
          e.preventDefault();
          handleAddToCart(e);
      }
  });
  console.log("DEBUG: Add to cart listener attached.");
});

// Function to handle adding main product and add-ons to the cart
async function handleAddToCart(event) {
  console.log("DEBUG: handleAddToCart function is being executed.");

  const addButton = event.target.closest('.product-form__submit');
  const productPopup = addButton ? addButton.closest('.quick-add-modal') : null;
  const productForm = productPopup ? productPopup.querySelector('form') : null;

  if (!productForm) {
      console.error("Product form not found within the product popup.");
      alert("Error: Unable to identify the product form in the popup.");
      return;
  }

  const mainProductVariantInput = productForm.querySelector('[name="id"]');
  if (!mainProductVariantInput) {
      console.error("Main product variant ID not found within the form.");
      alert("Error: Main product variant is missing.");
      return;
  }

  const mainProductVariantId = mainProductVariantInput.value;
  const selectedProducts = [];

  // Detect the dynamically updated quantity input
  const quantityInput = productPopup.querySelector('.quantity__input[name="quantity"]');
  const mainProductQuantity = quantityInput ? parseInt(quantityInput.value) : 1;

  console.log("DEBUG: Main Product ID:", mainProductVariantId);
  console.log("DEBUG: Main Product Quantity (Dynamic):", mainProductQuantity);

  // Add the main product with the dynamically detected quantity
  selectedProducts.push({
      id: mainProductVariantId,
      quantity: mainProductQuantity
  });

  // Collect add-ons (checked checkboxes)
  const complementarySection = productPopup ? productPopup.querySelector('.product__view-details .product-info-complementary') : null;
  if (complementarySection) {
      const addonCheckboxes = complementarySection.querySelectorAll('.addon-checkbox-input');
      addonCheckboxes.forEach(checkbox => {
          if (checkbox.checked) {
              const variantId = checkbox.getAttribute('data-variant-id');
              if (variantId) {
                  selectedProducts.push({ id: variantId, quantity: 1 });
              } else {
                  console.warn("DEBUG: Checked add-on missing variant ID:", checkbox);
              }
          }
      });
  } else {
      console.warn("DEBUG: Complementary section not found in popup.");
  }

  console.log("DEBUG: Selected Products before adding to cart:", selectedProducts);
  await addProductsToCartAndRedirect(selectedProducts);
}

// Function to add products to cart and redirect to cart page
async function addProductsToCartAndRedirect(products) {
  try {
      const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: products })
      });

      if (response.ok) {
          console.log("Products added to cart:", products);
          window.location.href = '/cart'; // Redirect to the cart page
      } else {
          const errorText = await response.text();
          console.error("Failed to add products:", errorText);
          alert("There was an error adding products to the cart.");
      }
  } catch (error) {
      console.error("Error occurred while adding products:", error);
      alert("There was an unexpected error. Please try again.");
  }
}
